var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLeondorado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aprendiendo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.3 240",
    style: {
      enableBackground: "new 0 0 167.3 240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF8400;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.5,239.5l36.9-23.2c1.7-1.1,3.4-2.2,5-3.3c5.8-3.9,11.4-8.1,16.6-12.8c2.1-1.9,4.2-3.8,6.1-5.9 c10.4-12,9.7-29.6,0.9-42.3c-1.8-2.5-3.8-4.9-6.2-6.9l-2.3-2h16c3.2,0,6.1-1.2,8.3-3.5l9.6-9.6c2.2-2.2,3.4-5.2,3.4-8.3V83 c0-4.9-3.2-9-7.7-10.3l-33.8-13.2l7.9-10.4c2.1-2.7,0.2-6.6-3.2-6.6h-17.9c0,0.1-55.9,0.1-55.9,0.1c-15,0-29.1,5.8-39.7,16.5 C6,69.7,0.2,83.8,0.2,98.7l0.1,87.8l10.1,7.8L72.5,239.5z M94.3,63.2L78.9,80.4c-2.7,2.8-4.3,6.7-4.3,10.6v24.6 c0,4.1,1.6,8,4.5,10.9l0.5,0.5l29.2,25.5l9.4,8.2c4.2,3.7,6.3,9,5.8,14.6c-0.6,5.6-3.7,10.4-8.6,13.1l-5.4,3.1L72,215.6l-51-39.2 l-0.1-77.7c0-9.5,3.7-18.4,10.4-25.1c6.7-6.7,15.6-10.4,25.1-10.4H94.3z M105.8,122.5l-10.6-9.2V93l15.4-17.2l35.6,13.9V118 l-4.4,4.4H105.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.9,33.7H41.1c-2.1,0-3.8-1.7-3.8-3.8v-26c0-1.3,0.8-2.5,2-3c1.2-0.5,2.6-0.3,3.6,0.5l13.8,12.1l13.3-12 c1.4-1.3,3.6-1.3,5-0.1L88.6,13l13.7-11.6c1-0.8,2.4-1,3.5-0.5c1.2,0.5,1.9,1.7,1.9,3v26C107.7,32,106,33.7,103.9,33.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeondorado);
export default __webpack_public_path__ + "static/media/logo_leondorado.17065bb96b7737e3723458fd32de4bbe.svg";
export { ForwardRef as ReactComponent };